type Props = {
  placeHolder: string;
  value: string;
  className?: string;
  onChange: (v: string) => void;
  maxLength: number;
  multiline?: boolean;
  errorMessage?: string;
};

function ErrorMessage({ message }: { message: string }) {
  return (
    <div className="absolute M8 text-primary-accent top-0 left-0 m-1 ml-2">
      {message}
    </div>
  );
}

export default function TextField({
  placeHolder,
  value,
  onChange,
  className,
  maxLength,
  errorMessage,
  multiline = false,
}: Props) {
  return (
    <div
      className={`border-2 rounded-lg p-4 flex items-center relative ${className}`}
    >
      {errorMessage && <ErrorMessage message={errorMessage} />}
      {multiline ? (
        <MultiLineTextField
          value={value}
          placeHolder={placeHolder}
          onChange={onChange}
          maxLength={maxLength}
        />
      ) : (
        <SingleLineTextField
          value={value}
          placeHolder={placeHolder}
          onChange={onChange}
          maxLength={maxLength}
        />
      )}
    </div>
  );
}

function SingleLineTextField({
  placeHolder,
  value,
  onChange,
  maxLength,
}: Pick<Props, 'placeHolder' | 'value' | 'onChange' | 'maxLength'>) {
  return (
    <input
      type="text"
      maxLength={maxLength}
      placeholder={placeHolder}
      className="bg-transparent outline-none M16 w-full"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}

function MultiLineTextField({
  placeHolder,
  value,
  onChange,
  maxLength,
}: Pick<Props, 'placeHolder' | 'value' | 'onChange' | 'maxLength'>) {
  return (
    <>
      <div className="absolute right-0 bottom-0 m-1 M12 md:M16 text-gray-300 bg-white p-1 rounded-sm ">
        {value.length}/2000
      </div>
      <textarea
        rows={5}
        maxLength={maxLength}
        placeholder={placeHolder}
        className="bg-transparent outline-none M16 min-h-[30px] w-full resize-none"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </>
  );
}
